class BD_Question {
  questionData = [];

  constructor(argQuestionData) {
    // TODO make sure score is not included in questionData
    this.questionData = argQuestionData;
  }

  showSubmitBtn(objMedia) {
    if (objMedia.question.questionData.type === "slider") {
      $(".questionCard").addClass("is-slider");
      $(".questionCard").find(".questionCard__actions").addClass("is-active");
    }

    const answers = objMedia.question.questionData.answers;
    // show submit button immediately if no answers
    if (!answers || answers.length == 0) {
      $(this.elms.questionCard).find(".questionCard__actions").addClass("is-active");
    }
  }

  static create(questionData) {
    //$('.questionCard__actions').removeClass('is-active')
    $(".questionCard").removeClass("is-slider");

    if (questionData.type === "multiple_choice") return new QuestionMultipleChoice(questionData);
    else if (questionData.type === "slider") return new QuestionSlider(questionData);
    else if (questionData.type === "word_cloud") return new QuestionWordCloud(questionData);

    return new QuestionBlank(questionData);
  }

  getEvents() {
    return [];
  }

  // implement getAnswer() for each question type
  getAnswer() {}

  /*
   * $el = submit button
   * ctx = current block object
   */
  submitAnswer($el, ctx) {
    const selectedAnswer = this.getAnswer(ctx);
    // if (selectedAnswer === null || selectedAnswer === undefined) return false;

    $el.attr("disabled", true);
    $el.addClass("is-loading");

    const afterResponse = () => {
      $el.removeAttr("disabled");
      $el.removeClass("is-loading");
    };

    this.submitAnswerRequest(selectedAnswer, afterResponse);
  }

	submitAnswerRequest(selectedAnswer, afterResponse = () => {}) {
    bdapi
      .post("game/submit-answer", {
        current_block: BD_GAME_LOGIC.getCurrentBlockID(),
        answer_data: selectedAnswer,
      })
      .then((res) => {
        const resData = res.data;
        const data = resData.data;

        BD_Variable.set(data.answer_variables);

        if (data) {
          BD_GAME_LOGIC.goTo(data.next_sequence, data.next_sequence_type);
          return false;
        }

				afterResponse();
      })
      .catch((err) => {
				afterResponse();
      });
  }
}

new BD_Question();
